import { render, staticRenderFns } from "./ResetPassPage.vue?vue&type=template&id=1d631104&scoped=true&"
import script from "./ResetPassPage.vue?vue&type=script&lang=js&"
export * from "./ResetPassPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d631104",
  null
  
)

export default component.exports